module.exports = __webpack_public_path__ + "static/media/gallery1.67299e2d.jpg";